<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.configuracaoRastreabilidade.materiais.titulo")',
        :voltarPara='{ route: "ConfiguracaoMaterial" }'
    )
    .bloco-cadastro-materiais
        h3 {{ $t('mensagens.configuracaoRastreabilidade.materiais.dadosCadastrais') }}
        .form-cadastro-material
            .form-cadastro-material__row
                label.form-cadastro-material__row-label.obrigatorio {{ $t('mensagens.configuracaoRastreabilidade.materiais.codigo') }}
                input.form-cadastro-material__row-input(
                    :placeholder='$t("mensagens.configuracaoRastreabilidade.materiais.codigoPlaceHolder")',
                    v-model='material.codigo',
                    maxlength='10'
                )
            .form-cadastro-material__row
                label.form-cadastro-material__row-label.obrigatorio {{ $t('mensagens.configuracaoRastreabilidade.materiais.nome') }}
                input.form-cadastro-material__row-input(
                    :placeholder='$t("mensagens.configuracaoRastreabilidade.materiais.nomePlaceHolder")',
                    v-model='material.nome'
                )
            .form-cadastro-material__row
                label.form-cadastro-material__row-label.obrigatorio {{ $t('mensagens.configuracaoRastreabilidade.materiais.tipos') }}
                el-select(
                    v-model='material.tipoId'
                    filterable,
                    value-key='id',
                    :placeholder="$t('mensagens.configuracaoRastreabilidade.materiais.selecione')"
                    @change="obterListas()"
                )
                    el-option(
                        v-for='(tipo, index) in tipos',
                        :key='`tipo-${tipo.codigo}`',
                        :label='tipo.nome',
                        :value='tipo.id'
                    ) {{ tipo.nome }}
            .form-cadastro-material__row(v-if="materialOrigemLista.length")
                label.form-cadastro-material__row-label.obrigatorio {{ $t('mensagens.configuracaoRastreabilidade.materiais.materialOrigem') }}
                el-select(
                    v-model='material.materialOrigemId'
                    filterable,
                    value-key='id',
                    :placeholder="$t('mensagens.configuracaoRastreabilidade.materiais.selecione')"
                )
                    el-option(
                        v-for='(material, index) in materialOrigemLista',
                        :key='`material-${material.codigo}`',
                        :label='material.nome',
                        :value='material.id'
                    ) {{ material.nome }}

            .form-cadastro-material__row(v-if="materialOrigemLista.length")
                label.form-cadastro-material__row-label.obrigatorio {{ $t('mensagens.configuracaoRastreabilidade.materiais.subproduto') }}
                el-select(
                    v-model='material.tipoSubprodutoId'
                    filterable,
                    value-key='id',
                    :placeholder="$t('mensagens.configuracaoRastreabilidade.materiais.selecione')"
                )
                    el-option(
                        v-for='(material, index) in subprodutoLista',
                        :key='`material-${material.codigo}`',
                        :label='material.nome',
                        :value='material.id'
                    ) {{ material.nome }}
        .footer
            .footer__btn.voltar(@click='goToListagemMateriais')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
            .footer__btn.salvar(@click='handlerSubmit')
                span {{ $t('mensagens.comuns.salvar') }}
                i.mdi.mdi-arrow-right
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import services from '@/services/ContratoOriginacaoService';
import mask from '@/utils/directives/mask.js';

export default {
    name: 'CadastroMaterial',
    components: {
        BaseHeader
    },
    directives: {
        maskBind: mask
    },
    data() {
        return {
            tipos: [],
            materialOrigem: [],
            subproduto: [],
            material: {
                nome: '',
                codigo: '',
                tipoId: '',
                tipoSubprodutoId: '',
                materialOrigemId: ''
            }
        };
    },
    computed: {
        materialOrigemLista() {
            const tipoSelecionado = this.tipos.find((item) => this.material?.tipoId === item?.id);

            if (tipoSelecionado && tipoSelecionado.codigo === 'SECUNDARIO') {
                return this.materialOrigem;
            }

            return [];
        },
        subprodutoLista() {
            const tipoSelecionado = this.tipos.find((item) => this.material?.tipoId === item?.id);

            if (tipoSelecionado && tipoSelecionado.codigo === 'SECUNDARIO') {
                return this.subproduto;
            }

            return [];
        },
        isValid() {
            return {
                codigo: {
                    isValid: this.material.codigo.length > 0,
                    message: this.$t('mensagens.configuracaoRastreabilidade.materiais.erros.codigo')
                },
                nome: {
                    isValid: this.material.nome.length > 0,
                    message: this.$t('mensagens.configuracaoRastreabilidade.materiais.erros.nome')
                },
                tipoId: {
                    isValid: !!this.material.tipoId,
                    message: this.$t('mensagens.configuracaoRastreabilidade.materiais.erros.tipo')
                },

                materialOrigemId: {
                    isValid: this.materialOrigemLista.length === 0 || !!this.material.materialOrigemId,
                    message: this.$t('mensagens.configuracaoRastreabilidade.materiais.erros.materialOrigem')
                },
                tipoSubprodutoId: {
                    isValid:
                        this.subprodutoLista.length === 0 ||
                        !!this.material.tipoSubprodutoId,
                    message: this.$t(
                        'mensagens.configuracaoRastreabilidade.materiais.erros.subproduto'
                    )
                }
            };
        }
    },
    mounted() {
        this.buscarDados();
        this.obterTiposMateriais();
    },
    methods: {
        async buscarDados() {
            const id = this.$route.params.id;

            if (!id) {
                return;
            }

            await services.detalheMaterial(id)
                .then(({ data }) => {
                    this.material = {
                        nome: data.nome,
                        codigo: data.codigo,
                        tipoId: data.tipoMaterialOuput.id,
                        tipoSubprodutoId: data?.tipoSubprodutoOutput?.id,
                        materialOrigemId: data.materialOrigem?.id || ''
                    };

                    if (data.tipoMaterialOuput.id === 2) {
                        this.obterListaMateriais();
                        this.obterListaSubprodutos();
                    }
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                    this.$router.push({ path: '/materiais' });
                });
        },
        async obterListaSubprodutos() {
            const tipoSelecionado = this.tipos.find((item) => this.material?.tipoId === item?.id);

            if (this.materialOrigem.length || (tipoSelecionado && tipoSelecionado.codigo !== 'SECUNDARIO')) {
                return;
            }

            try {
                const response = await services.buscarSubprodutos();

                this.subproduto = response?.data;
            } catch {
                this.$notify.error(
                    this.$t(
                        'mensagens.configuracaoRastreabilidade.materiais.erroObterSubprodutos'
                    )
                );
            }
        },
        obterListas() {
            this.obterListaMateriais();
            this.obterListaSubprodutos();
        },
        async obterListaMateriais() {
            const tipoSelecionado = this.tipos.find((item) => this.material?.tipoId === item?.id);

            if (this.materialOrigem.length || (tipoSelecionado && tipoSelecionado.codigo !== 'SECUNDARIO')) {
                return;
            }

            try {
                const response = await services.buscarMaterialPorTipo();

                this.materialOrigem = response?.data;
            } catch {
                this.$notify.error(
                    this.$t(
                        'mensagens.configuracaoRastreabilidade.materiais.erroObterTipos'
                    )
                );
            }
        },
        async obterTiposMateriais() {
            try {
                const response = await services.buscarTiposMaterial();
                this.tipos = response?.data;
            } catch {
                this.$notify.error(
                    this.$t(
                        'mensagens.configuracaoRastreabilidade.materiais.erroObterTipos'
                    )
                );
            }
        },
        goToListagemMateriais() {
            this.$router.push({ name: 'ConfiguracaoMaterial' });
        },
        async handlerSubmit() {
            const inputValido = this.validaInput();
            
            if (inputValido) {
                try {
                    const payload = {
                        nome: this.material.nome,
                        codigo: this.material.codigo,
                        tipoId: this.material.tipoId,
                        tipoSubprodutoId: this.material.tipoSubprodutoId || null,
                        materialOrigemId: this.material.materialOrigemId || null
                    };
                    if (this.$route.params.id) {
                        payload.id = this.$route.params.id;

                        const { data } = await services.editarMaterial(payload);
                        this.$notify.success(data);
                        this.$router.push({ name: 'ConfiguracaoMaterial' });
                    } else {
                        const { data } = await services.cadastrarMaterial(payload);

                        this.$notify.success(data);
                        this.$router.push({ name: 'ConfiguracaoMaterial' });
                    }
                } catch (error) {
                    this.$notify.error(
                        error?.response?.data?.message ||
                        this.$t('mensagens.configuracaoRastreabilidade.materiais.erroAoCadastro')
                    );
                }
            }
        },
        validaInput() {
            const validations = this.isValid;

            for (const key in validations) {
                if (Object.prototype.hasOwnProperty.call(validations, key)) {
                    const field = validations[key];

                    if (!field.isValid) {
                        this.$notify.error(field.message);
                        return false;
                    }
                }
            }

            return true;
        }
    }
};
</script>

<style lang="scss">
.bloco-cadastro-materiais {
    margin: 20px;
}

.form-cadastro-material {
    margin-top: 10px;
    background-color: $white;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-radius: $default-border-radius;
    @include default-box-shadow();
}

.form-cadastro-material__row {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.form-cadastro-material__row-label {
    color: $primary;
    font-weight: bold;
}

.obrigatorio::after {
    content: '* ';
    color: red;
    margin-left: 3px;
}

.form-cadastro-material__row-input {
    width: 50%;
    height: 40px;
    border-radius: $default-border-radius;
    border: 1px solid $default-border-color;
    outline: 0;
    padding: 0 15px;
}
.el-select {
    width: 50%;
}

.form-cadastro-material__row-input-area {
    display: flex;
    gap: 10px;
    align-items: center;
}

.form-cadastro-material__btn-remover-cpf-cnpj {
    width: 48px;
    height: 32px;
    background-color: $background-danger;
    color: $font-danger;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: $default-border-radius;
}

.form-cadastro-material__btn-add-cpf-cnpj {
    width: 210px;
    height: 40px;
    margin-top: 5px;
    background-color: $white;
    color: $primary;
    font-weight: bold;
    border: 1px solid $primary;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;
    border-radius: $default-border-radius;
    cursor: pointer;

    i.el-icon-plus {
        font-weight: bold;
    }
}

.form-cadastro-material__btn-add-cpf-cnpj:hover {
    background-color: var(--primary);
    color: $white;
}

.footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}

.salvar {
    background-color: var(--primary);
    color: $white;
}

.salvar:hover {
    background-color: var(--secondary);
}

.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
